import { render, staticRenderFns } from "./BoPradiabetes.vue?vue&type=template&id=76ca9e32&"
import script from "./BoPradiabetes.vue?vue&type=script&lang=js&"
export * from "./BoPradiabetes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports